import { i18n } from './i18n/index'
import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import echarts from 'echarts'
// 鏉冮檺鎸囦护
import permission from './components/Permission'
// console.log(i18n.tc('h.vip.nickname'),'i18ni18n+++');
// Vue.prototype.$t = i18n.tc

import '@/icons' // icon
import '@/permission' // permission control
Vue.use(permission)
Vue.use(ElementUI, { locale:{
	el: {

	    ...locale.el,

	    pagination: {

	      pagesize: `${i18n.tc('h.info.fenye')}`,

	      total: `${i18n.tc('h.info.gong')} {total} ${i18n.tc('h.info.tiao')}`,

	      goto: `${i18n.tc('h.info.goto')}`,

	      pageClassifier: `${i18n.tc('h.info.ye')}`

	    }
}} })
Vue.use(VCharts)



import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer)
Vue.prototype.langs = {
  "":"",
  "en_US":"英文",
  "vi_VN":"越南",
  "th_TH":"泰国",
  "zh_CN":"中文",
  "zh_TW":"中国台湾",
  "id_ID":"印尼",
  "fa_YU":"法语",
  "han_YU":"韩语",
  "tu_ER":"土耳其",
  "pu_YA":"葡萄牙",
  "xi_NI":"西班牙",
  "jp_JP":"日本",
  "ru_RU":"俄语",
  "de_YU":"德语",
  "bj_YU":"保加利亚语",
  "bl_YU":"波兰语",
  "dm_YU":"丹麦语",
  "fl_YU":"芬兰语",
  "hl_YU":"荷兰语",
  "rd_YU":"瑞典语",
  "wkl_YU":"乌克兰语",
  "xl_YU":"希腊语",
  "xyl_YU":"匈牙利语",
  "ydl_YU":"意大利语",
  "ar_YU":"阿拉伯语"
}
Vue.prototype.clangs = {
  "zh_TW":"中国台湾",
  "en_US":"英文",
  "ar_YU":"阿拉伯语",
  "fa_YU":"法语",
//  "ph_PH":"菲律宾语",
  "de_DE":"德语",
  "it_IT":"意大利语",
  "jp_JP":"日语",
  "ms_MY":"马来语",
  "xi_NI":"西班牙语",
  "uz_UZ":"乌兹别克",
  "pu_YA":"葡萄牙语",
  "ru_RU":"俄语",
  "vi_VN":"越南",
  "th_TH":"泰国",
  "id_ID":"印尼",
  "han_YU":"韩语",
  "tu_ER":"土耳其",
  "zh_CN":"中国",
}
Vue.prototype.timeZoneList = [
        // {label:"伦敦+0",value:"0"},
        // {label:"迪拜+4",value:"4"},
        // {label:"叙利亚+2",value:"2"},
        // {label:"西班牙+1",value:"1"},
        // {label:"葡萄牙+0",value:"0"},
        // {label:"巴西-3",value:"-3"},
        // {label:"墨西哥-6",value:"-6"},
        // {label:"墨西哥-7",value:"-7"},
        // {label:"墨西哥-8",value:"-8"},
        {label:"中国+8",value:"+8"},
        {label:"摩洛哥+1",value:"+1"}
]
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js